import http from "./httpService";
import config from "./config.json";

export const logInAdmin = (admin) => {
    return http.post(`${config.localApi}/api/admin/login`, JSON.stringify(admin));
};

//Admin Box Edit Data (put method)
export const updateAdminBoxTxt = (dataId, editedPost) => {
    return http.post(`${config.localApi}/api/admin/BoxUpdate/${dataId}`, JSON.stringify(editedPost));
};
